<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-06-06 15:24:04
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-10-23 18:22:31
-->
<template>
	<el-dialog :visible.sync="visible" width="540px" :close-on-click-modal="false">
		<div slot="title">
			<span>商品同步</span>
			<span
				class="yx-color-text-secondary font-h4-regular ml-12 cursor-pointer hover"
				@mouseenter="iconClass = 'i-back-hover'"
				@mouseleave="iconClass = 'i-back'"
				@click="back"
			>
				<i :class="['mb-2', iconClass]"></i>
				返回上一步
			</span>
		</div>
		<div class="flex-row flex-align-center">
			<div class="yx-color-text-secondary font-h4-regular" style="width: 200px">
				<p>同步类型</p>
				<p class="yx-color-text-primary mt-4">{{ syncInfo.label }}</p>
				<p class="mt-24">同步信息</p>
				<p class="yx-color-text-primary mt-4">{{ syncInfo.instName }}</p>
				<p class="yx-color-text-primary mt-4" v-if="syncInfo.activityId">{{ syncInfo.activityId }}</p>
				<p class="yx-color-text-primary mt-4" v-if="syncInfo.thirdShopId">{{ syncInfo.thirdShopId }}</p>
				<p class="yx-color-text-primary mt-4" v-if="syncInfo.productId">{{ syncInfo.productId }}</p>
			</div>
			<div style="margin-left: 40px">
				<template v-if="isLoading">
					<el-progress type="circle" :percentage="ratio" :stroke-width="12" color="#2475FF" :width="121" stroke-linecap="butt"></el-progress>
					<p class="yx-color-text-primary fz-14 mt-12">{{ errMsg }}</p>
				</template>
				<el-result icon="error" :title="errMsg" v-else-if="isError"></el-result>
				<el-result icon="success" title="已完成商品同步" v-else></el-result>
			</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<span class="fz-12 yx-color-text-secondary mr-12" v-if="isLoading">关闭弹窗不影响同步进度</span>
			<el-button @click="visible = false">关闭</el-button>
			<!-- <el-button type="primary" @click="reAsync" v-if="isError">重新同步</el-button> -->
		</span>
	</el-dialog>
</template>
<script>
import { institutionListJava } from '@/api/teamManage';
import dataMap from '@/utils/dataMap';
// 异步状态
const ASYNC_PENDING_STATUS = 10; //执行中
const ASYNC_SUCCESS_STATUS = 40; //全部成功
const ASYNC_PARTSUCCESS_STATUS = 41; //部分成功
const ASYNC_FAIL_STATUS = 42; //失败
export default {
	name: 'AsyncDialog',
	props: {
		sourceData: {
			type: Object,
			default: () => {},
		},
		platformId: {
			type: [Number, String],
			default: '',
		},
	},
	data() {
		return {
			visible: false,
			institutionList: [],
			iconClass: 'i-back',
		};
	},
	computed: {
		status() {
			return this.sourceData.status;
		},
		ratio() {
			return this.sourceData?.taskProgress || 0;
		},
		errMsg() {
			return this.sourceData?.errorMsg || '';
		},
		syncInfo({ institutionList }) {
			let paramObj = this.sourceData?.paramObj || {};
			let instSyncInfo = paramObj?.instSyncInfo || {};
			let instName = institutionList?.find(item => item.instId == instSyncInfo?.instId)?.instName || '';
			if (instSyncInfo.productId) {
				let temOBj = {
					[+dataMap.PLATFORM_DY.value]: {
						label: '指定商品同步',
						instName: `${instName}`,
						activityId: `活动ID ${instSyncInfo?.activityId}`,
						productId: `商品ID ${instSyncInfo?.productId}`,
					},
					[+dataMap.PLATFORM_SP.value]: {
						label: '指定商品同步',
						instName: `${instName}`,
						thirdShopId: `店铺ID ${instSyncInfo?.thirdShopId}`,
						productId: `商品ID ${instSyncInfo?.productId}`,
					},
				};
				return temOBj[this.sourceData.platformId] || temOBj[+dataMap.PLATFORM_DY.value];
			} else if (instSyncInfo.activityId) {
				return {
					label: '指定活动同步',
					instName: `${instName}`,
					activityId: `活动ID ${instSyncInfo?.activityId}`,
				};
			} else {
				return {
					label: '全量同步商品',
					instName: `${instName}`,
				};
			}
		},
		isLoading() {
			return this.status === ASYNC_PENDING_STATUS;
		},
		isError() {
			return this.status === ASYNC_FAIL_STATUS || this.status === ASYNC_PARTSUCCESS_STATUS;
		},
		isSuccess() {
			return this.status === ASYNC_SUCCESS_STATUS;
		},
	},
	methods: {
		show() {
			this.visible = true;
			this.getList();
		},
		hide() {
			this.visible = false;
		},
		reAsync() {
			this.$emit('reAsync');
		},
		back() {
			this.$emit('back');
			this.hide();
		},
		async getList() {
			const { platformId } = this;
			const temPF = {
				[dataMap.PLATFORM_DY.value]: '12',
				[dataMap.PLATFORM_SP.value]: '31',
			};
			let params = {
				tripartiteType: temPF[platformId], //业务类型
				platformId,
			};
			this.institutionList = await institutionListJava(params);
		},
	},
};
</script>
<style lang="less" scoped>
/deep/ .el-dialog__body {
	padding: 24px !important;
}
/deep/.el-progress__text {
	color: @color-primary;
	font-family: DINAlternate-Bold, DINAlternate;
	font-size: 32px !important;
}
/deep/.el-result {
	padding-top: 16px;
	padding-bottom: 16px;
	p {
		font-size: 14px;
	}
}
/deep/.el-progress-circle__track {
	stroke: fadeout(@color-primary, 90%);
}
</style>
